import { createAction } from 'redux-actions';

export const changeRoundBordersToOnAction = createAction('CHANGE_ROUND_BORDERS_ON');
export const changeRoundBordersToOffAction = createAction('CHANGE_ROUND_BORDERS_OFF');
